import React from "react";
import ChecklistTypeLabel from "../ChecklistTypeLabel";

interface Props {
  rentalLabel: string;
  returnalLabel: string;
  showRentalLabel: boolean;
  showReturnalLabel: boolean;
  rentalChild: React.ReactNode;
  returnalChild: React.ReactNode;
  style?: React.CSSProperties;
}

class ChecklistItemLayout extends React.Component<Props, any> {
  public render() {
    const {style} = this.props;
    const {showRentalLabel, showReturnalLabel} = this.props;
    const {rentalLabel, returnalLabel} = this.props;
    const {rentalChild, returnalChild} = this.props;

    return (
      <div style={{...style, display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap', gap: 16}}>
        {rentalChild &&
          <div style={{display: 'flex', flex: '1 1 350px'}}>
            {showRentalLabel &&
              <ChecklistTypeLabel title={rentalLabel} style={{marginTop: 2}}/>
            }
            <div style={{flexShrink: 1, flexGrow: 1, flexBasis: 0}}>
              {rentalChild}
            </div>
          </div>
        }
        {returnalChild &&
          <div style={{display: 'flex', flex: '1 1 350px'}}>
            {showReturnalLabel &&
              <ChecklistTypeLabel title={returnalLabel} style={{marginTop: 2}}/>
            }
            <div style={{flexShrink: 1, flexGrow: 1, flexBasis: 0}}>
              {returnalChild}
            </div>
          </div>
        }
      </div>
    );
  }
}

export default ChecklistItemLayout;


// WEBPACK FOOTER //
// ./src/checklist/layout/ChecklistItemLayout.tsx